import {
  Toast
} from 'vant'


export function mobileMsgErr(message) {
  Toast.fail(message);
}

export function mobileMsgSuc(message) {
  Toast.success(message);
}

export function errMsgCallback(respData, errorCode) {
  if (respData.respCode) {
    if (errorCode[respData.respCode]) {
      mobileMsgErr(errorCode[respData.respCode]);
    } else {
      mobileMsgErr("服务器异常，请联系客服");
    }
  }
}

export function dateFormat(fmt, date) {
  let ret;
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    };
  };
  return fmt;
}


export function getOS() {
    let platform = "PC";
    if (navigator.userAgent.search(/micromessenger/i) >= 0) {
      platform = "WeChat";
    } else if (navigator.userAgent.search(/(alipayclient|aliapp)/i) >= 0) {
      platform = "Alipay";
    } else if (navigator.userAgent.search(/(iphone|ipad|ipod)/i) >= 0) {
      platform = "iOS";
    } else if (navigator.userAgent.search(/android/i) >= 0) {
      platform = "Android";
    } else if (navigator.userAgent.search(/windows phone/i) >= 0) {
      platform = "WinPhone";
    } else {
      platform = "PC";
    }
    return platform;
  }